import { Inspection } from '@stormwater-software/lib-inspection-templates';
import xhrService from '../xhrService';
import { Finding } from './finding';
const baseUrl = '/api/projects';

export type ProjectInspection = Omit<Inspection, 'id'> & {
  id: number;
  findings: Array<Finding>;
};

export interface CustomInspectionFilters {
  inspectionTemplateTypeId?: number;
  inspectionType?: string;
}

export const customPrintInspectionApi = {
  index: (id: number | null, filters?: CustomInspectionFilters): any => {
    const params = new URLSearchParams();
    
    if (filters?.inspectionTemplateTypeId) {
      params.append('inspectionTemplateTypeId', filters.inspectionTemplateTypeId.toString());
    }
    
    if (filters?.inspectionType) {
      params.append('inspectionType', filters.inspectionType);
    }
    
    const queryString = params.toString();
    const url = queryString 
      ? `${baseUrl}/${id}/custominspections?${queryString}`
      : `${baseUrl}/${id}/custominspections`;

    return xhrService
      .get(url)
      .then((response) => response.data);
  },
};

export default customPrintInspectionApi;
